import Vue from 'vue'
import router from './router'
import VueApollo from 'vue-apollo'
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client'
import VueJwtDecode from 'vue-jwt-decode'

// Install the vue plugin
Vue.use(VueApollo)

// Name of the localStorage item
const AUTH_TOKEN = 'tokenJWTWeb'
const REFRESH_TOKEN = 'refreshJWTWeb'
// Http endpoint
const httpEndpoint = process.env.VUE_APP_HASURA_URL
// Files URL root
export const filesRoot = process.env.VUE_APP_FILES_ROOT || httpEndpoint.substr(0, httpEndpoint.indexOf('/graphql'))

Vue.prototype.$filesRoot = filesRoot

// Config
const defaultOptions = {
  // You can use `https` for secure connection (recommended in production)
  httpEndpoint,
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  // eslint-disable-next-line no-constant-condition
  wsEndpoint: null,
  // LocalStorage token
  tokenName: AUTH_TOKEN,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,

  // Override default apollo link
  // note: don't override httpLink here, specify httpLink options in the
  // httpLinkOptions property of defaultOptions.
  // link: myLink

  // Override default cache
  // cache: myCache

  // Override the way the Authorization header is set
  getAuth: async tokenName => {
    // get the authentication token from local storage if it exists
    // return the headers to the context so httpLink can read them
    try {
      if (localStorage.getItem(tokenName) !== null || sessionStorage.getItem(tokenName) !== null) {
        const crypto = Vue.CryptoJS
        const token = crypto.AES.decrypt(
          localStorage.getItem(tokenName) || sessionStorage.getItem(tokenName) || ' ',
          process.env.VUE_APP_CRYPTO_PASS,
        ).toString(crypto.enc.Utf8)
        const dateExpirate = token ? Vue.moment.unix(VueJwtDecode.decode(token).exp) : Vue.moment()
        if (Vue.moment().isBefore(dateExpirate)) {
          if (token) {
            return `Bearer ${token}`
          } else {
            return ''
          }
        } else {
          let tokenJWT
          await Vue.axios.post('/token/refresh')
            .then(response => {
              const crypto = Vue.CryptoJS
              const token = crypto.AES.encrypt(
                response.data.token,
                process.env.VUE_APP_CRYPTO_PASS,
              ).toString()
              const refresh = crypto.AES.encrypt(
                response.data.refresh,
                process.env.VUE_APP_CRYPTO_PASS,
              ).toString()
              const user = JSON.parse(localStorage.getItem('userAdmin')) || JSON.parse(sessionStorage.getItem('userAdmin'))
              if (user.keep) {
                localStorage.setItem(AUTH_TOKEN, token)
                localStorage.setItem(REFRESH_TOKEN, refresh)
              } else {
                sessionStorage.setItem(AUTH_TOKEN, token)
                sessionStorage.setItem(REFRESH_TOKEN, refresh)
              }
              tokenJWT = response.data.token
            }).catch(async error => {
              if (error.response && error.response.status === 401 && error.response.data.msg && error.response.data.msg === 'Missing cookie "refresh_token_cookie"') {
                await Vue.axios.post('/token/logout').then(
                  async _ => {
                    if (Object.keys(localStorage).includes('userAdmin')) {
                      localStorage.removeItem(AUTH_TOKEN)
                      localStorage.removeItem(REFRESH_TOKEN)
                    } else if (Object.keys(sessionStorage).includes('userAdmin')) {
                      sessionStorage.removeItem(AUTH_TOKEN)
                      sessionStorage.removeItem(REFRESH_TOKEN)
                    }
                    router.push('/')
                  },
                )
              } else {
                console.log('aqui1')
                await Vue.axios.post('/token/anonymous')
                  .then(response => {
                    const crypto = Vue.CryptoJS
                    const token = crypto.AES.encrypt(
                      response.data.token,
                      process.env.VUE_APP_CRYPTO_PASS,
                    ).toString()
                    const refresh = crypto.AES.encrypt(
                      response.data.refresh,
                      process.env.VUE_APP_CRYPTO_PASS,
                    ).toString()
                    sessionStorage.setItem(AUTH_TOKEN, token)
                    sessionStorage.setItem(REFRESH_TOKEN, refresh)
                    tokenJWT = response.data.token
                  }).catch(_ => {
                    console.log('aqui4')
                  })
              }
            })
          if (tokenJWT) {
            return `Bearer ${tokenJWT}`
          } else {
            return ''
          }
        }
      } else {
        let tokenJWT
        await Vue.axios.post('/token/anonymous')
          .then(response => {
            const crypto = Vue.CryptoJS
            const token = crypto.AES.encrypt(
              response.data.token,
              process.env.VUE_APP_CRYPTO_PASS,
            ).toString()
            const refresh = crypto.AES.encrypt(
              response.data.refresh,
              process.env.VUE_APP_CRYPTO_PASS,
            ).toString()
            sessionStorage.setItem(AUTH_TOKEN, token)
            sessionStorage.setItem(REFRESH_TOKEN, refresh)
            tokenJWT = response.data.token
          }).catch(_ => {
            console.log('aqui2')
          })
        if (tokenJWT) {
          return `Bearer ${tokenJWT}`
        } else {
          return ''
        }
      }
    } catch (e) {
      localStorage.removeItem('userAdmin')
      localStorage.removeItem(AUTH_TOKEN)
      localStorage.removeItem(REFRESH_TOKEN)
      sessionStorage.removeItem('userAdmin')
      sessionStorage.removeItem(AUTH_TOKEN)
      sessionStorage.removeItem(REFRESH_TOKEN)
      let tokenJWT
      await Vue.axios.post('/token/anonymous')
        .then(response => {
          const crypto = Vue.CryptoJS
          const token = crypto.AES.encrypt(
            response.data.token,
            process.env.VUE_APP_CRYPTO_PASS,
          ).toString()
          const refresh = crypto.AES.encrypt(
            response.data.refresh,
            process.env.VUE_APP_CRYPTO_PASS,
          ).toString()
          sessionStorage.setItem(AUTH_TOKEN, token)
          sessionStorage.setItem(REFRESH_TOKEN, refresh)
          tokenJWT = response.data.token
        }).catch(_ => {
          console.log('aqui3')
        })
      if (tokenJWT) {
        return `Bearer ${tokenJWT}`
      } else {
        return ''
      }
    }
  },

  // Additional ApolloClient options
  // apollo: { ... }

  // Client local data (see apollo-link-state)
  // clientState: { resolvers: { ... }, defaults: { ... } }
}

// Call this in the Vue app file
export function createProvider (options = {}) {
  // Create apollo client
  const { apolloClient, wsClient } = createApolloClient({
    ...defaultOptions,
    ...options,
  })
  apolloClient.wsClient = wsClient

  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        // fetchPolicy: 'cache-and-network',
      },
    },
    errorHandler (error) {
      // if (error.message.includes('JWTExpired')) {
      //   this.$axios.post('/token/refresh')
      //     .then(response => {
      //       const crypto = Vue.CryptoJS
      //       const token = crypto.AES.encrypt(
      //         response.data.token,
      //         process.env.VUE_APP_CRYPTO_PASS,
      //       ).toString()
      //       localStorage.setItem(AUTH_TOKEN, token)
      //     }).catch(error => {
      //       console.log(error)
      //     })
      // } else {
      // eslint-disable-next-line no-console
      console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message)
      // }
    },
  })

  return apolloProvider
}

// Manually call this when user log in
export async function onLogin (apolloClient, token) {
  if (typeof sessionStorage !== 'undefined' && token) {
    sessionStorage.setItem(AUTH_TOKEN, token)
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (login)', 'color: orange;', e.message)
  }
}

// Manually call this when user log out
export async function onLogout (apolloClient) {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem(AUTH_TOKEN)
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (logout)', 'color: orange;', e.message)
  }
}
